// extracted by mini-css-extract-plugin
export var sideMenu = "SideMenu-module--sideMenu--1A9qQ";
export var language = "SideMenu-module--language--1t_PO";
export var btn = "SideMenu-module--btn--3ZOuX";
export var rightArrow = "SideMenu-module--rightArrow--2sQlH";
export var downArrow = "SideMenu-module--downArrow--2gBOk";
export var localeContainer = "SideMenu-module--localeContainer--toVYm";
export var locale = "SideMenu-module--locale--1eASN";
export var visible = "SideMenu-module--visible--1V65l";
export var verticalMenu = "SideMenu-module--verticalMenu--3jJEx";
export var links = "SideMenu-module--links--3OzRn";
export var linksBox = "SideMenu-module--linksBox--1gELQ";
export var menuLink = "SideMenu-module--menuLink--1-ZCC";
export var homeLink = "SideMenu-module--homeLink--2NkLH";
export var currentPage = "SideMenu-module--currentPage--KrCWH";
export var bottom = "SideMenu-module--bottom--1vcLt";